import { Avatar } from "primereact/avatar";
import * as React from "react";
import "./PrwcAvatar.scss";

const PrwcAvatar = (props: any) => {
  const { label, shape = "circle", size = "large", image, icon, style, className } = props;

  return (
    <>
      {image ? (
        <Avatar
          shape={shape}
          image={image}
          icon={icon}
          size={size}
          style={style}
        ></Avatar>
      ) : (
        <Avatar
          label={label}
          shape={shape}
          icon={icon}
          size={size}
          style={style}
          className={className}
        ></Avatar>
      )}
    </>
  );
};

export default PrwcAvatar;
